import { CategoricalPalette, SdBin } from './types';

// 4-class RdYlGn palette for stand density bins. Greens = room to grow,
// red = overstocked / thinning candidate. Kept in sync manually with the
// precompute pipeline that renders the on-map raster PNGs.
export const SD_PALETTE: CategoricalPalette<SdBin> = {
  colors: {
    '0_to_30':  '#1A9850',
    '30_to_60': '#A6D96A',
    '60_to_80': '#FDAE61',
    '80_plus':  '#D73027',
  },
  labels: {
    '0_to_30':  '0–30%',
    '30_to_60': '30–60%',
    '60_to_80': '60–80%',
    '80_plus':  '80%+',
  },
  order: ['0_to_30', '30_to_60', '60_to_80', '80_plus'],
};
